(function () {
	'use strict';

	var module = angular.module('uwAgenda.programinfo');
	module.factory('ProgramInfoService', ['$rootScope', '$http', 'WebsocketService', 'WebsocketRegisterType', 'SharedAgendaService', ProgramInfoServiceFn]);

	// infoscreen notfication service
	function ProgramInfoServiceFn($rootScope, $http, WebsocketService, WebsocketRegisterType, SharedAgendaService) {

		var baseUrl = '/api/programinfos';

		var service = {
			fetchNotifications: fetchNotifications,
			getNotification: getNotification,
			saveNotification: saveNotification,
			removeNotification: removeNotification,
			registerWebsocket: registerWebsocket,
			mailToUser: mailToUser,
			readByUser: readByUser,
			Broadcast: {
				ProgramInfoDelete: "program.info:delete",
				ProgramInfoUpdate: "program.info:update",
				ProgramInfoInit: "program.info:init"
			},
			data: []
		};

		return service;

		// get notifications as list
		function fetchNotifications() {
			var url = baseUrl;
			return $http.get(url).then(function (response) {
				service.data = response.data;

				var i = 0;
				var length = service.data.length;

				// strip html from title
				for (i; i < length; i++) {
					var infoObject = service.data[i];
					service.data[i] = cleanUpInfoObject(infoObject);
				}

				return service.data;
			});
		}

		// clean the info object
		function cleanUpInfoObject(infoObject) {
			infoObject.title = stripHtml(infoObject.title);
			return infoObject;
		}

		// strip html from string
		function stripHtml(string) {
			return string.replace(/<(?:.|\n)*?>/gm, '');
		}


		// get notification by id
		function getNotification(infoId) {
			var url = baseUrl + '/' + infoId;
			return $http.get(url).then(function (response) {
				// strip html from title
				var infoObject = response.data;
				infoObject = cleanUpInfoObject(infoObject);
				return infoObject;
			});
		}

		// save notification
		function saveNotification(item) {
			var url = baseUrl;
			return $http.post(url, item);
		}

		// remove notification
		// we actually don't manipulate the service data because
		// the websocket will send update notification for the list
		function removeNotification(item) {
			var infoId = item.id;
			var url = baseUrl + '/' + infoId;
			return $http({
				method: 'DElETE',
				url: url
			});
		}

		// register websocket listeners
		function registerWebsocket() {

			// register program info listener for notifications
			WebsocketService.register(WebsocketRegisterType.ProgramInfoSave, function (message) {
				// reload notifications from server
				service.fetchNotifications().then(function (programInfoList) {
					$rootScope.$broadcast(service.Broadcast.ProgramInfoUpdate, programInfoList);
				});

			});

			// register program info delete listern for list updates
			WebsocketService.register(WebsocketRegisterType.ProgramInfoDelete, function (message) {
				service.fetchNotifications().then(function (programInfoList) {
					$rootScope.$broadcast(service.Broadcast.ProgramInfoDelete, programInfoList);
				});
			});

		}

		// mail notification to logged in user
		function mailToUser(id) {
			var url = baseUrl + '/mail/' + id + '/' + SharedAgendaService.currentUser().id;
			return $http.get(url);
		}

		// mark notification as read by user
		function readByUser(id, read) {
			var url = baseUrl + '/readbyuser/' + id + '/' + read;
			return $http({
				method: 'POST',
				url: url
			});
		}
	}

})();
